import { useEffect, useRef, useState, useCallback } from "react";
import { IoMdDownload } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {useSearchParams, useLocation,useNavigate } from "react-router-dom";

import MindMappingReportAHeader from "./MindMappingReportAHeader";
import MindMappingReportAFirstSection from "./MindMappingReportAFirstSection";
import MindMappingReportASecondSection from "./MindMappingReportASecondSection";
import MindMappingReportAThirdSection from "./MindMappingReportAThirdSection";
import MindMappingReportAFourthSection from "./MindMappingReportAFourthSection";
import MindMappingReportAFifthSection from "./MindMappingReportAFifthSection";
import MindMappingReportASixthSection from "./MindMappingReportASixthSection";
import MindMappingReportASeventhSection from "./MindMappingReportASeventhSection";
import { apiFetch } from "../../utils/apiFetch";

import "./MindMappingReportA.css";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const MindMappingReportA = ({ hideUI = false, setToggle, onClose,toggle }) => {
  const sectionRefs = useRef([]);

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate=useNavigate()

  const stateReport = location.state?.reportData || null;

  const userId = searchParams.get("userId");
  const reportId = searchParams.get("reportId");

  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ------------------------------------
     FETCH REPORT (PDF MODE)
  -------------------------------------*/
  const fetchReportById = useCallback(async (userId, reportId) => {
    try {
      const res = await apiFetch(
        `/api/mind-mapping/report-list/${userId}`
      );


      if (!res.ok) throw new Error("Failed to fetch reports");

      const data = await res.json();
      if (!data.success || !data.reports?.length) return null;

      return data.reports.find(
        (r) => String(r.id) === String(reportId)
      );
    } catch (err) {
      console.error("❌ Error fetching report:", err);
      return null;
    }
  }, []);

    useEffect(() => {
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    localStorage.setItem("fromMobileReports", "true");
  }

  return () => {
    localStorage.removeItem("fromMobileReports");
  };
}, []);

  /* ------------------------------------
     LOAD DATA
  -------------------------------------*/
  useEffect(() => {
    const load = async () => {
      try {
        if (stateReport) {
          setReportData(stateReport);
          return;
        }

        if (userId && reportId) {
          const report = await fetchReportById(userId, reportId);
          setReportData(report);
          return;
        }

        throw new Error("No report source available");
      } catch (err) {
        console.error("❌ Report load failed:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [stateReport, userId, reportId, fetchReportById]);

  /* ------------------------------------
   
  const downloadReport = async () => {
    setToggle(false);
    onClose();

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = 210;
    const pdfHeight = 297;
    const margin = 10; // Left & Right margin in mm
    
    // Calculate the width available for the image after margins
    const contentWidth = pdfWidth - (margin * 2); 

    let yOffset = margin;

    for (let section of sectionRefs.current) {
      if (!section) continue;

      await new Promise(res => setTimeout(res, 200));

      const canvas = await html2canvas(section, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#FFFFFF",
      });

      // Maintain aspect ratio while fitting into contentWidth
      const imgHeight = (canvas.height * contentWidth) / canvas.width;

      if (yOffset + imgHeight > pdfHeight - margin) {
        pdf.addPage();
        yOffset = margin;
      }

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        margin,   // 👈 Changed from 0 to margin to shift right
        yOffset,
        contentWidth, // 👈 Use contentWidth so it doesn't touch edges
        imgHeight
      );

      yOffset += imgHeight + 5;
    }

    pdf.save("MindMapping_Report_A by Marsmate AI.pdf");
  };
  -------------------------------------*/
 const downloadReport = async () => {
  try {
    // 1. UI Feedback
    setToggle(false);
    onClose();

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = 210;
    const pdfHeight = 297;
    const topMargin = 15;
    const bottomMargin = 15;
    const usableHeight = pdfHeight - topMargin - bottomMargin;

    let yOffset = topMargin;

    // 2. Loop through sections
    for (let i = 0; i < sectionRefs.current.length; i++) {
      const section = sectionRefs.current[i];
      if (!section) continue;

      const canvas = await html2canvas(section, {
        scale: 2,           // Keeps it sharp
        useCORS: true,      // Allows images from your backend
        backgroundColor: "#FFFFFF",
        windowWidth: 1500,  // 🔥 Forces desktop layout rendering
      });

      const imgData = canvas.toDataURL("image/png");
      
      // Maintain aspect ratio based on the 1200px width
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      if (yOffset + imgHeight > topMargin + usableHeight) {
        pdf.addPage();
        yOffset = topMargin;
      }

      pdf.addImage(imgData, "PNG", 0, yOffset, pdfWidth, imgHeight);
      yOffset += imgHeight + 5;
    }

    pdf.save("MindMapping_Report_A.pdf");
  } catch (error) {
    console.error("PDF download error:", error);
    alert("download feature is coming soon");
  }
};
  /* ------------------------------------
     GUARDS
  -------------------------------------*/
  if (loading) return <div style={{ padding: 40 }}>Loading report…</div>;

  if (!reportData)
    return (
      <div style={{ padding: 40, color: "red" }}>
        Failed to load report data
      </div>
    );

  /* ------------------------------------
     RENDER
  -------------------------------------*/
  return (
    <div className="mind-mapping-report-a-page">
      {!hideUI && (
        <div className="mind-mapping-report-a-download-container">
              <button
  className="back-btn-report"
  onClick={() => {
    const fromMobile = localStorage.getItem("fromMobileReports");
    localStorage.removeItem("fromMobileReports");
    onClose();
    setToggle(false);
    if (fromMobile === "true") {
      navigate(`/mobile/reports`);
    } else {
      navigate(-1);
    }
  }}
>
  <FaArrowLeftLong size={26} />
</button>


          <button
            className="mind-mapping-report-a-download-btn"
            onClick={downloadReport}
          >
            Download <IoMdDownload size={26} />
          </button>
        </div>
      )}

      {/* 👀 Visible UI */}
      <div className="mind-mapping-report-a-section">
        {[
          MindMappingReportAHeader,
          MindMappingReportAFirstSection,
          MindMappingReportASecondSection,
          MindMappingReportAThirdSection,
          MindMappingReportAFourthSection,
          MindMappingReportAFifthSection,
          MindMappingReportASixthSection,
          MindMappingReportASeventhSection,
        ].map((Component, index) => (
          <div key={index} className="mind-mapping-report-pdf-section">
            <Component res={reportData} toggle={toggle} />
            
          </div>
        ))}
      </div>

      {/* 🔒 Hidden PDF Layout */}
      <div className="mind-mapping-report-pdf-only">
        {[
          MindMappingReportAHeader,
          MindMappingReportAFirstSection,
          MindMappingReportASecondSection,
          MindMappingReportAThirdSection,
          MindMappingReportAFourthSection,
          MindMappingReportAFifthSection,
          MindMappingReportASixthSection,
          MindMappingReportASeventhSection,
        ].map((Component, index) => (
          <div
            key={index}
            ref={(el) => (sectionRefs.current[index] = el)}
            className="mind-mapping-report-pdf-section"
          >
            <Component res={reportData} toggle={toggle} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MindMappingReportA;
